module.exports = window.styled;